import { jsx as _jsx } from "react/jsx-runtime";
import { Flex } from '../layout/flex/index.js';
export const ButtonGroup = ({ children, className, direction = 'row', justify = 'end', condensed, }) => {
    return (_jsx(Flex, { className: className, direction: direction, gap: condensed ? null : 'medium', justify: justify, children: children }));
};
